import React from 'react'

const Design = () => {
  return (
    <div className='py-6'>
        <h1 className='text-center mb-4 text-[22px] md:text-[30px] text-[#1b1b1b] font-semibold mt-5 md:mt-0'>Modern, minimalist design</h1>
        <img src="/images/escapist__design.webp" alt="" />
    </div>
  )
}

export default Design